const unpack = x => (x || "").split(/[ ,]+/);
const pack = xs => (xs || []).join(" ");

function flatten_rec(x) {
	if (typeof x === "string") {
		return unpack(x);
	} else if (typeof x === "object") {
		var xs = [];
		for (const a of x) xs = xs.concat(flatten_rec(a));
		return xs;
	} else {
		return [];
	}
}

function flatten_all() {
	return flatten_rec(arguments);
}

function classes() {
	return pack(flatten_all(arguments));
}

function props_without(props) {
	var to_remove_set = {};
	const to_remove = flatten_all([...arguments].slice(1));
	for (var i = 0; i < to_remove.length; i++) to_remove_set[to_remove[i]] = true;

	var return_props = {};
	for (const k in props) if (!to_remove_set[k]) return_props[k] = props[k];

	return return_props;
}

export {
	unpack,
	pack,
	flatten_all,
	classes,
	props_without
};



// WEBPACK FOOTER //
// ./src/CUtil.js